module.exports = __webpack_public_path__ + "static/media/ic_share.398091b8.svg";